var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#B90BDB", fillRule: "evenodd", d: "M17.247 14.674v2.573a.747.747 0 0 1-.26.568l-.106.075-4.893 2.906c-.4.239-.889.269-1.312.09l-.177-.09-4.891-2.906a.743.743 0 0 1-.357-.513l-.011-.13v-2.573l5.259 3.122c.402.239.89.269 1.312.09l.177-.09 5.259-3.122zM1.878 8.324L10.5 3.206c.404-.24.887-.27 1.311-.09l.178.09L21.75 9v5.25a.75.75 0 0 1-.616.738L21 15h-1.501a.75.75 0 0 1-.739-.614l-.012-.136v-3.468l-6.76 4.014a1.455 1.455 0 0 1-1.311.09l-.178-.09-8.62-5.12c-.463-.273-.502-.93-.116-1.268l.115-.084L10.5 3.206 1.88 8.324z" })
  );
});